




































































































































































































































































import Component from 'vue-class-component';
import SapData from '@/components/AccountingSheet/SapData.vue';
import AccountingSheetController from '@/controllers/AccountingSheet';
import { AccountingSheetInterface, AccountingSheetStatus } from '@/types/AccountingSheet';
import EntityHelperMixin from '@/mixins/EntityHelperMixin';
import UserMixin from '@/mixins/UserMixin';
import { Mixins } from 'vue-property-decorator';
import DocumentsMixin from '@/mixins/Documents';

@Component({
  components: {
    SapData,
  },
})
export default class AccountingSheetPage extends Mixins(EntityHelperMixin, UserMixin, DocumentsMixin) {
  headers = [
    {
      text: 'Участок',
      value: 'clientName',
    },
    {
      text: 'SAP ID',
      value: 'clientSapId',
    },
    {
      text: 'Вид услуг',
      value: 'workTypeName',
    },
    {
      text: 'Центр затрат',
      value: 'costCenterName',
    },
    {
      text: 'Счет затрат',
      value: 'costAccount',
    },
    {
      text: 'Выполненный объём',
      value: 'size',
    },
    {
      text: 'ед.измерения',
      value: 'unitName',
    },
    {
      text: 'Производительность, %',
      value: 'performance',
    },
    {
      text: 'Качество, %',
      value: 'quality',
    },
    {
      text: 'Стоимость обратной единицы',
      value: 'tariff',
    },
    {
      text: 'Суммма',
      value: 'totalWithoutTax',
    },
  ];

  cancelDialog = false;

  cancelComment = '';

  recallDialog = false;

  accountingSheet: AccountingSheetInterface | null = null;

  loadingAccountingSheet = false;

  isSendingApprovingRequest = false;

  isSendingCancellingRequest = false;

  isSendingRecallingRequest = false;

  isSendingStatusRequest = false;

  selectedStatus = AccountingSheetStatus.SUPPLIER_CONFIRMATION_AWAIT;

  beforeMount() {
    this.loadAccountingSheet();
  }

  get isStatusAllowToCancel(): boolean {
    const allowedStatuses = [
      AccountingSheetStatus.CREATED,
      AccountingSheetStatus.SUPPLIER_CONFIRMATION_AWAIT,
      AccountingSheetStatus.CONTROLLING_APPROVAL_AWAIT,
      AccountingSheetStatus.DIADOC_SIGNING_AWAIT,
      AccountingSheetStatus.ACCOUNTANT_APPROVAL_AWAIT,
    ];
    return this.accountingSheet !== null && allowedStatuses.includes(this.accountingSheet.status);
  }

  get isControllingAction(): boolean {
    return this.accountingSheet !== null && this.accountingSheet.status === AccountingSheetStatus.CONTROLLING_APPROVAL_AWAIT && this.isControlling;
  }

  get isAccountantAction(): boolean {
    return this.accountingSheet !== null && this.accountingSheet.status === AccountingSheetStatus.ACCOUNTANT_APPROVAL_AWAIT && this.isAccountant;
  }

  get isAccountantPaymentAction(): boolean {
    return this.accountingSheet !== null && this.accountingSheet.status === AccountingSheetStatus.PAYMENT_AWAIT && this.isAccountant;
  }

  get isSignerAction(): boolean {
    return this.accountingSheet !== null && this.accountingSheet.status === AccountingSheetStatus.DIADOC_SIGNING_AWAIT && this.isSigner;
  }

  get isAvailableButton(): boolean {
    return this.isControllingAction || this.isAccountantAction || this.isAccountantPaymentAction || this.isSignerAction;
  }

  get isProblem(): boolean {
    return this.accountingSheet !== null && this.accountingSheet.status === AccountingSheetStatus.PROBLEM && this.isHR;
  }

  get showComment(): boolean {
    return this.accountingSheet !== null
      && this.accountingSheet.comment !== null
      && this.accountingSheet.comment !== ''
      && (
        this.accountingSheet.status === AccountingSheetStatus.PROBLEM
        || this.accountingSheet.status === AccountingSheetStatus.RECALLED
      );
  }

  get btnName(): string {
    if (this.isControllingAction) {
      return 'Отправить на подпись';
    }
    if (this.isAccountantAction) {
      return 'Отправить в SAP';
    }
    if (this.isAccountantPaymentAction) {
      return 'Отправить в оплачено';
    }
    if (this.isSignerAction) {
      return 'Подписать';
    }
    return 'Отправить дальше';
  }

  get availableChangeStatuses(): string[] {
    return [
      AccountingSheetStatus.SUPPLIER_CONFIRMATION_AWAIT,
      AccountingSheetStatus.CONTROLLING_APPROVAL_AWAIT,
      AccountingSheetStatus.DIADOC_SIGNING_AWAIT,
      AccountingSheetStatus.ACCOUNTANT_APPROVAL_AWAIT,
      AccountingSheetStatus.PAYMENT_AWAIT,
      AccountingSheetStatus.PAYMENT_DONE,
    ];
  }

  onError(error: any): void {
    this.$bus.$emit('notification', `Возникла ошибка при выполнении операции, попробуйте позже - ${error}`, 'error');
    console.error(error);
  }

  onSuccess(result: any): void {
    console.log('Result after request - ', result);
    this.$bus.$emit('notification', 'Операция успешно выполнена', 'success');
    this.loadAccountingSheet();
  }

  async onSubmitApprovingSheet(): Promise<void> {
    if (this.isControllingAction) {
      this.onSubmitApproveByControlling();
    } else if (this.isAccountantAction) {
      this.onSubmitApproveByAccountant();
    } else if (this.isAccountantPaymentAction) {
      this.onSubmitPaymentDoneByAccountant();
    } else if (this.isSignerAction) {
      this.onSubmitSignBySigner();
    } else {
      this.$bus.$emit('notification', 'У вас нет прав для выполнения операций с листом учета', 'warning');
    }
  }

  async onSubmitChangeStatus(): Promise<void> {
    try {
      if (!this.accountingSheet) {
        throw new Error("Accounting sheet doesn't exist");
      }
      this.isSendingStatusRequest = true;
      const response = await AccountingSheetController.statusChange(this.accountingSheet.id, this.selectedStatus);
      const [error, result] = response.result;
      if (error) this.onError(error);
      else this.onSuccess(result);
    } catch (error) {
      this.onError(error);
    } finally {
      this.isSendingStatusRequest = false;
    }
  }

  async onSubmitApproveByControlling(): Promise<void> {
    try {
      if (!this.accountingSheet) {
        throw new Error("Accounting sheet doesn't exist");
      }
      this.isSendingApprovingRequest = true;
      const response = await AccountingSheetController.statusApproveByControlling(this.accountingSheet.id);
      const [error, result] = response.result;
      if (error) this.onError(error);
      else this.onSuccess(result);
    } catch (error) {
      this.onError(error);
    } finally {
      this.isSendingApprovingRequest = false;
    }
  }

  async onSubmitPaymentDoneByAccountant(): Promise<void> {
    try {
      if (!this.accountingSheet) {
        throw new Error("Accounting sheet doesn't exist");
      }
      this.isSendingApprovingRequest = true;
      const response = await AccountingSheetController.statusPaymentDoneByAccountant(this.accountingSheet.id);
      const [error, result] = response.result;
      if (error) this.onError(error);
      else this.onSuccess(result);
    } catch (error) {
      this.onError(error);
    } finally {
      this.isSendingApprovingRequest = false;
    }
  }

  async onSubmitApproveByAccountant(): Promise<void> {
    try {
      if (!this.accountingSheet) {
        throw new Error("Accounting sheet doesn't exist");
      }
      (this.$refs.sapData as any).$v.$touch();
      if ((this.$refs.sapData as any).$v.$invalid) {
        this.$bus.$emit('notification', 'Пожалуйста, заполните данные для SAP', 'warning');
        return;
      }

      this.isSendingApprovingRequest = true;

      const isUpdatedSapData: boolean = await (this.$refs.sapData as any).onSubmit(true);
      if (!isUpdatedSapData) return;
      const response = await AccountingSheetController.statusApproveByAccountant(this.accountingSheet.id);

      const [error, result] = response.result;
      if (error) this.onError(error);
      else this.onSuccess(result);
    } catch (error) {
      this.onError(error);
    } finally {
      this.isSendingApprovingRequest = false;
    }
  }

  async onSubmitSignBySigner(): Promise<void> {
    try {
      if (!this.accountingSheet) {
        throw new Error("Accounting sheet doesn't exist");
      }
      this.isSendingApprovingRequest = true;

      const [error, result] = (await AccountingSheetController.sign(this.accountingSheet.id)).result;
      if (error) this.onError(error);
      else this.onSuccess(result);
    } catch (error) {
      this.onError(error);
    } finally {
      this.isSendingApprovingRequest = false;
    }
  }

  async cancelAccountingSheet(): Promise<void> {
    this.cancelDialog = false;
    try {
      if (!this.accountingSheet) {
        throw new Error("Accounting sheet doesn't exist");
      }
      if (!this.isStatusAllowToCancel) {
        throw new Error("Status of the accounting sheet doesn't allow you to change it");
      }

      this.isSendingCancellingRequest = true;
      const response = await AccountingSheetController.cancel(this.accountingSheet.id, this.cancelComment);
      const [error, result] = response.result;
      if (error) this.onError(error);
      else this.onSuccess(result);
    } catch (error) {
      this.onError(error);
    } finally {
      this.isSendingCancellingRequest = false;
    }
  }

  async recallAccountingSheet(): Promise<void> {
    this.recallDialog = false;
    try {
      if (!this.accountingSheet) {
        throw new Error("Accounting sheet doesn't exist");
      }
      if (!this.isProblem) {
        throw new Error("Status of the accounting sheet doesn't allow you to recall it");
      }

      this.isSendingRecallingRequest = true;
      const response = await AccountingSheetController.recall(this.accountingSheet.id);
      const [error, result] = response.result;
      if (error) this.onError(error);
      else this.onSuccess(result);
    } catch (error) {
      this.onError(error);
    } finally {
      this.isSendingRecallingRequest = false;
    }
  }

  async loadAccountingSheet() {
    if (!Number(this.$route?.params?.id)) {
      return null;
    }
    this.loadingAccountingSheet = true;
    try {
      const response = await AccountingSheetController.loadSingle(Number(this.$route.params.id));
      const [error, result] = response.result;
      if (error) {
        this.$bus.$emit('notification', 'Возникла ошибка при получении листа учета, попробуйте позже', 'error');
        console.error(error);
        return null;
      }
      if (result.data) {
        this.accountingSheet = result.data;
        this.makeDocumentsLinks(result.data);
        this.formatMonetaryFields(result.data);
        return result.data;
      }

      return null;
    } catch (e) {
      console.error(e);
      return null;
    } finally {
      this.loadingAccountingSheet = false;
    }
  }

  async loadWorkTypeById(ids: number[]) {
    try {
      const filter = {
        $or: ids.map((id) => ({ oo_id: { $like: String(id) } })),
      };
      const workType = await this.loadEntityListing('Work', { filter: JSON.stringify(filter) }, 'network-only');
      if (workType?.length) {
        return workType;
      }
      return [];
    } catch (e) {
      console.error(e);
      return [];
    }
  }

  protected formatMonetaryFields(object: AccountingSheetInterface) {
    object.groups.forEach((item) => {
      Object.assign(item, {
        tariff: this.$n(item.tariff, 'decimal'),
        totalWithoutTax: this.$n(item.totalWithoutTax, 'decimal'),
      });
    });
  }
}
